import { useCallback, useMemo, useRef } from 'react'
import type { LookupParcelByRobustIdResult } from '@/modules/properties/use-cases'
import { ParcelInfoCacheContext } from './parcel-info-cache-context'

type ParcelInfoCacheProviderProps = {
  children: React.ReactNode
}

export function ParcelInfoCacheProvider({ children }: ParcelInfoCacheProviderProps) {
  const cacheRef = useRef<Map<string, LookupParcelByRobustIdResult | null>>(new Map())

  const get = useCallback(
    (robustId: string) => cacheRef.current.get(robustId),
    [],
  )

  const set = useCallback(
    (robustId: string, info: LookupParcelByRobustIdResult | null) => {
      cacheRef.current.set(robustId, info)
    },
    [],
  )

  const clear = useCallback(() => {
    cacheRef.current.clear()
  }, [])

  const value = useMemo(() => ({ get, set, clear }), [get, set, clear])

  return (
    <ParcelInfoCacheContext.Provider value={value}>
      {children}
    </ParcelInfoCacheContext.Provider>
  )
}
